// extracted by mini-css-extract-plugin
export default {"App":"App_App__xmmW1","spider-float":"App_spider-float__MVge9","spider-sense":"App_spider-sense__zaKld","thwip":"App_thwip__Uxqhb"};